module.exports = __webpack_public_path__ + "media/images/hms/hms-answer-437bff66508d2937533c122fcb02103d.jpg";